import { createFileRoute } from '@tanstack/react-router';
import { ensureCatalogEntries } from '../../features/catalog/queries';
import { CatalogPage } from '../../pages/CatalogPage';
import { CATS } from '../../data/categories';
import type { CategoryId } from '../../features/catalog/model';
import { catalogStep } from '../../lib/seo/breadcrumb';
import { CATALOG_API_COUNT } from '../../lib/catalogSize';
import { staticPageHead } from '../../lib/seo/staticPageHead';
import { m } from '../../paraglide/messages';

export interface CatalogSearch {
  q?: string;
  category?: CategoryId;
}

export const Route = createFileRoute('/_site/catalog')({
  staticData: { catalogText: true },
  loader: ({ context }) => ensureCatalogEntries(context.queryClient),
  // `?q=` seeds the search box: the sitewide WebSite SearchAction (orgSchema.ts)
  // points Google's sitelinks searchbox here, so a crawler-submitted query lands
  // pre-filtered instead of on an empty catalog.
  validateSearch: (search: Record<string, unknown>): CatalogSearch => {
    const q = typeof search.q === 'string' ? search.q : undefined;
    const category = CATS.some(({ id }) => id === search.category)
      ? (search.category as CategoryId)
      : undefined;
    return { ...(q ? { q } : {}), ...(category ? { category } : {}) };
  },
  head: () =>
    staticPageHead({
      path: '/catalog',
      title: m.head_catalog_title(),
      description: m.head_catalog_description({ count: CATALOG_API_COUNT }),
      crumb: catalogStep(),
    }),
  component: CatalogRoute,
});

function CatalogRoute() {
  const { q, category } = Route.useSearch();
  return <CatalogPage initialQuery={q} initialCategory={category} />;
}
